export default "__VITE_ASSET__AM51CgQD__"